import React from "react";
import { Route, Switch,Link,Router } from "react-router-dom";
import Privacy_policy from "./pages/Privacy_policy";
// import Faq from "./pages/Faq";
// import Faqpage from "./pages/Faqpage";
// import Usermanual from "./pages/Usermanual";
// import OnePager from "./pages/OnePager";

export default function App() {
  return (
    <>
    <Switch>
      <Route exact path='/' component={Privacy_policy} />

      {/* <Route exact path='/privacypolicy' component={Privacy_policy} /> */}
      {/* <Route exact path='/AC/FAQ' component={Faq} /> */}
      {/* <Route exact path='/AC/FAQ' component={Faqpage} />
      <Route exact path='/AC/usermanual' component={Usermanual}/>
      <Route exact path='/AC/onepager' component={OnePager}/> */}
      
    </Switch>
   
    </>
  )
}